export const memberships = [
  {
    name: 'Standard',
    priceKey: 'standard',
    tier: 'Standard',
    description: [
      'Number of play sessions: Mon-Fri (excl.half term)',
      'Early access at weekends'
    ]
  },
  {
    name: 'Premium',
    priceKey: 'premium',
    tier: 'Premium',
    description: [
      'Number of play sessions: Any time',
      'Free entry at weekends',
      'Free admission for one adult',
      '4 free guest passes',
      '10% discount at the cafe',
      '15% discount on parties',
      "Free extras at your child's party",
      'Early access at weekends'
    ]
  },
  {
    name: 'Standard - Sibling',
    priceKey: 'standardSibling',
    tier: 'Standard',
    sibling: true,
    description: [
      'Number of play sessions: Mon-Fri (excl.half term)',
      'Early access at weekends'
    ]
  },
  {
    name: 'Premium - Sibling',
    priceKey: 'premiumSibling',
    tier: 'Premium',
    sibling: true,
    description: [
      'Number of play sessions: Any time',
      'Free entry at weekends',
      'Free admission for one adult',
      '4 free guest passes',
      '10% discount at the cafe',
      '15% discount on parties',
      "Free extras at your child's party",
      'Early access at weekends'
    ]
  },
  {
    name: 'Family - Default',
    priceKey: 'familyTwoAdultsTwoChildren',
    tier: 'Standard',
    family: true,
    familyPlan: 'twoAdultsTwoChildren',
    description: [
      'Standard membership covering 2 adults and 2 children in the same household',
      'Number of play sessions: Mon-Fri (excl. half term)',
      'Early access at weekends'
    ]
  },
  {
    name: 'Family - Multiple',
    priceKey: 'familyMultipleChildrenPerChild',
    tier: 'Standard',
    family: true,
    familyPlan: 'multipleChildren',
    minChildren: 3,
    maxChildren: 8,
    description: [
      'Single membership for 1 adult and several children in the same family (choose how many below)',
      'Priced per child at the Standard sibling rate',
      'Number of play sessions: Mon-Fri (excl. half term)',
      'Early access at weekends'
    ]
  }
]

/** @param {typeof memberships[number]} membership */
export function clampFamilyChildCount (count, membership) {
  if (!membership.family) return 2
  if (membership.familyPlan === 'twoAdultsTwoChildren') return 2
  const min = membership.minChildren || 2
  const max = membership.maxChildren || 8
  const n = parseInt(count, 10)
  if (Number.isNaN(n)) return min
  return Math.max(min, Math.min(n, max))
}

export {
  formatMembershipPayAmount,
  fetchMembershipPrices,
  DEFAULT_MEMBERSHIP_PRICES,
  formatEmailMembershipPrice,
  getMembershipBillingAmount,
  mergeMembershipPrices
} from './membershipPrices'

export default memberships
